<template>
    <flex-element :element-type="elementType" class="f-inline-flex f-self-start" class-default-inline="f-border-1 f-px-0.5 f-py-0.25 f-min-h-7 f-min-w-25 f-bg-white">
        <textarea
            v-plaintext
            class="f-w-1/1"
            :name="inputNameNew"
            :placeholder="renderPlaceholder"
            :required="renderRequired"
            :aria-label="ariaLabelNew"
            :aria-labelledby="ariaLabelledByNew"
            :value="inputValueNew"
            @input="onInput"
            @invalid="onInvalidInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ATextarea } from '@/data/data-models';

export default {
    name: 'a-textarea',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Multi-line Text Input',
        },

        inputName: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        placeholderDefault: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        requiredDefault: {
            type: Boolean,
            default: false,
        },

        validationMessage: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            cssDisplay: 'inline-flex',
            inputNameNew: '',
            inputValueNew: '',
            placeholderNew: '',
            requiredNew: '',
            validationMessageNew: '',
        };
    },

    computed: {
        renderPlaceholder() {
            return this.placeholderNew || this.placeholderDefault;
        },

        renderRequired() {
            return this.requiredNew || this.requiredDefault;
        },

        updatedElement() {
            return new ATextarea({
                ...this.updatedBaseElement,
                inputName: this.inputNameNew,
                placeholder: this.placeholderNew,
                inputValue: this.inputValueNew,
                required: this.requiredNew,
                validationMessage: this.validationMessageNew,
            });
        },
    },

    methods: {
        setFieldValues() {
            this.inputNameNew = this.inputName;
            this.placeholderNew = this.placeholder;
            this.requiredNew = this.required;
            this.validationMessageNew = this.validationMessage;
        },

        onInput(e) {
            e.target.setCustomValidity('');
        },

        onInvalidInput(e) {
            e.target.setCustomValidity(this.validationMessageNew);
        },
    },
};
</script>
